import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

const GalleryList = () => {
  const data = useStaticQuery(graphql`
    query galleryListQuery {
        allMdx(filter: {frontmatter: {type: {eq: "PhotoIndex"}}}) {
          edges {
            node {
              id
              slug
              frontmatter {
                title
              }
            }
          }
        }
      }
  `)

  var pages = data.allMdx.edges.map(article => {
    return (
      <li>
        <Link
          to={"/" + article.node.slug}
          key={article.node.slug}
          className="navbar-item"
        >
          {article.node.frontmatter.title}
        </Link>
      </li>
    )
  })
  
  return (<ul className="menu-list">
          {pages}
          </ul>);
}

export default GalleryList